<template>
  <div id="app">
    <header class="header navbar-area">
      <Toolbar />
      <Navbar />
    </header>
    <router-view />
    <Footer />
  </div>
</template>

<style>

</style>

<script>
  import Toolbar from './components/shared/Toolbar.vue'
  import Navbar from './components/shared/Navbar.vue'
  import Footer from './components/shared/Footer.vue'

  export default {
    name: 'App',
    components: {
      Toolbar,
      Navbar,
      Footer
    },
    metaInfo: {
      title: "Tribinnov Africa - Tribe Of Innovation",
      meta: [
        {
          name: "description", content: "Tribinnov Africa is a research & development company, startup and venture lab that conducts research on problems in various industries and create products from these problems.]="
        },
        { name: "keywords", content: "investment, finance, tribinnov, tribinnov africa, tribe of innovation, tribe, africa, nigeria, funding, crowdfunding, fundraiser" }
      ]
    }
  };
</script>